<template>
  <LandingHomeSectionTemplate
    v-bind="props"
    :class="cn('text-white', props.class)"
    bg-color="#2A4E81"
    :image-path="props.imagePath || 'stocks-bg'"
    :title="t('title')"
    :description="t('description')"
    :primary-cta="{
      text: t('primaryCtaText'),
      variant: 'alternative',
      to: '/etf',
    }"
    :secondary-cta="{ hidden: true }"
  />
  <!-- :secondary-cta="{
      class: 'text-white/75 hover:text-white',
    }" -->
</template>

<script setup lang="ts">
import { type HomepageSectionTemplateProps } from "./Template.vue"

const props = defineProps<Partial<HomepageSectionTemplateProps>>()
const { t } = useI18n({ useScope: "local" })
</script>

<i18n lang="json">
{
  "he": {
    "title": "קרן הנאמנות AI S&P",
    "description": "קרן נאמנות שעוקבת אחרי מודל FINQFIRST, המחזיק תמיד את 10 המניות המדורגות ראשונות על ידי ה-AI שלנו אשר נבנה כדי לנצח את מדד ה-S&P. ללא דמי ניהול, רק השתתפות ברווח.",
    "primaryCtaText": "אני רוצה לרכוש את הקרן"
  },
  "en": {
    "title": "The first AI-driven fund manager \n:min-md designed to challenge any index",
    "description": "Launching a new generation of ETFs — grounded in science, not stories.",
    "primaryCtaText": "Explore our ETFs"
  }
}
</i18n>
